import React from 'react';
import { Fragment, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { AnomalyChart } from "./anomalyChart";

export function ViewChart(props) {
    const values = [true, 'sm-down', 'md-down', 'lg-down', 'xl-down', 'xxl-down'];
    const [fullscreen, setFullscreen] = useState(true);
    const [show, setShow] = useState(false);

    function handleShow(breakpoint) {
        setFullscreen(breakpoint);
        setShow(true);
    }
    return (

        <Fragment>
            <AnomalyChart />

            <Button variant="outline-dark" onClick={() => handleShow(true)}>Развернуть</Button>
            <Modal show={show} fullscreen={fullscreen} onHide={() => setShow(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Диаграмма аномалий</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <AnomalyChart />
                </Modal.Body>
            </Modal>
        </Fragment>
    );
}
